import { makeStyles } from '@material-ui/core';
import styled from 'styled-components';

export const useStyles = makeStyles({
    th: {
        fontWeight: 'bold',
        borderTop: 'none !important',
        borderBottom: 'none !important',
        fontSize: '16px',
    },
    totalRow: {
        '& > tr': {
            '& > td:nth-child(4)': {
                paddingLeft: '20px !important',
            },
        },
    },
    td: {
        borderTop: 'none !important',
        borderRight: '1px solid rgba(0,0,0,0.02) !important',
    },
    tableContainer: {
        display: 'block',
        maxWidth: '100%',
    },
    table: {
        minWidth: '100px !important',
    },
    tbody: {
        '& > tr': {
            '& > td:nth-child(4)': {
                '& > div[class^="empty-budget"]': {
                    textAlign: 'initial !important',
                },
            },
        },
    },
});

export const TotalLabel = styled.span`
    font-size: 16px;
    font-weight: bold;
    margin: 0;
    padding-left: 80px;
`;

export const CampaignHeader = styled.span`
    padding-left: 4.7em !important;
`;

export const DailyBudgetHeader = styled.span`
    padding-left: 8px;
`;
